// extracted by mini-css-extract-plugin
export default {"root":"listsubheader_root__qUuIx"};